module.exports = __webpack_public_path__ + "static/media/coupe3.aaa59dc6.jpg";